module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFiltersMobile":{"displayCatalogFilters":"Filtrovat"}},"de":{"CatalogFiltersMobile":{"displayCatalogFilters":"Filter"}},"sk":{"CatalogFiltersMobile":{"displayCatalogFilters":"Filtrovať"}}}')
  delete Component.options._Ctor
}
